<template>
  <div class="hot-sale-page">
    <div class="page-header">
      <!-- 移除标题和副标题 -->
    </div>

    <div class="hot-sale-content">
      <!-- 左侧：基础飘屏配置 -->
      <div class="feature-left">
       
        <!-- 8. 图片热卖特效 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 6h12M2 10h12" stroke="#4ecdc4" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="5" cy="6" r="1.5" fill="#ff6b6b"/>
                <circle cx="11" cy="10" r="1.5" fill="#ffe66d"/>
              </svg>
            </div>
            <span>热卖飘屏</span>
            <label class="header-toggle" style="margin-left: auto;">
              <input type="checkbox" v-model="config.hotImageEffect.enabled" />
              <span class="toggle-track"></span>
            </label>
            <button class="icon-reset-btn" title="恢复默认" @click="e => handleResetClick(e, resetConfig)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>
          </div>
          <div class="card-body">
            <div class="config-list">
              <div :class="{ disabled: !config.hotImageEffect.enabled }">
                <div class="config-item">
                  <label>热卖模式选择</label>
                  <div class="radio-group">
                    <button class="radio-btn" :class="{ active: config.hotImageEffect.mode === 'single' }" @click="config.hotImageEffect.mode = 'single'">单品热卖</button>
                    <button class="radio-btn" :class="{ active: config.hotImageEffect.mode === 'multi' }" @click="config.hotImageEffect.mode = 'multi'">多品热卖</button>
                  </div>
                </div>

                <div class="config-row" style="margin-top: 12px;">
                   <div class="config-item">
                     <div class="label-with-action">
                       <label>热卖起点随机</label>
                     </div>
                     <div class="range-inputs">
                       <input type="number" v-model="config.hotImageEffect.startMin" class="cyber-input mini" placeholder="从" />
                       <span class="range-sep">至</span>
                       <input type="number" v-model="config.hotImageEffect.startMax" class="cyber-input mini" placeholder="到" />
                     </div>
                   </div>

                   <div class="config-item">
                     <label>热卖增加随机</label>
                     <div class="range-inputs">
                       <input type="number" v-model="config.hotImageEffect.increaseMin" class="cyber-input mini" placeholder="从" />
                       <span class="range-sep">至</span>
                       <input type="number" v-model="config.hotImageEffect.increaseMax" class="cyber-input mini" placeholder="到" />
                     </div>
                   </div>

                   <div class="config-item" style="flex: 0 0 65px;">
                     <label>出现频率</label>
                     <div class="range-inputs">
                       <input type="number" v-model="config.hotImageEffect.frequency" class="cyber-input mini" />
                       <span class="field-unit">秒</span>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 9. 库存飘屏功能 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 6h12M2 10h12" stroke="#4ecdc4" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="5" cy="6" r="1.5" fill="#4ecdc4"/>
                <circle cx="11" cy="10" r="1.5" fill="#00d4ff"/>
              </svg>
            </div>
            <span>库存飘屏</span>
            <label class="header-toggle" style="margin-left: auto;">
              <input type="checkbox" v-model="config.inventoryEffect.enabled" />
              <span class="toggle-track"></span>
            </label>
            <button class="icon-reset-btn" title="恢复默认" @click="e => handleResetClick(e, resetInventoryConfig)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>
          </div>
          <div class="card-body">
            <div class="config-list">
              <div :class="{ disabled: !config.inventoryEffect.enabled }">
                <div class="config-item">
                  <label>库存模式选择</label>
                  <div class="radio-group">
                    <button class="radio-btn" :class="{ active: config.inventoryEffect.mode === 'single' }" @click="config.inventoryEffect.mode = 'single'">单品库存</button>
                    <button class="radio-btn" :class="{ active: config.inventoryEffect.mode === 'multi' }" @click="config.inventoryEffect.mode = 'multi'">多品库存</button>
                  </div>
                </div>

                <div class="config-row" style="margin-top: 12px;">
                   <div class="config-item">
                     <div class="label-with-action">
                       <label>库存起点随机</label>
                     </div>
                     <div class="range-inputs">
                       <input type="number" v-model="config.inventoryEffect.startMin" class="cyber-input mini" placeholder="从" />
                       <span class="range-sep">至</span>
                       <input type="number" v-model="config.inventoryEffect.startMax" class="cyber-input mini" placeholder="到" />
                     </div>
                   </div>

                   <div class="config-item">
                     <label>库存减少随机</label>
                     <div class="range-inputs">
                       <input type="number" v-model="config.inventoryEffect.decreaseMin" class="cyber-input mini" placeholder="从" />
                       <span class="range-sep">至</span>
                       <input type="number" v-model="config.inventoryEffect.decreaseMax" class="cyber-input mini" placeholder="到" />
                     </div>
                   </div>

                   <div class="config-item" style="flex: 0 0 65px;">
                     <label>出现频率</label>
                     <div class="range-inputs">
                       <input type="number" v-model="config.inventoryEffect.frequency" class="cyber-input mini" />
                       <span class="field-unit">秒</span>
                     </div>
                   </div>
                 </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 10. 购买飘屏功能 -->
        <div class="panel-card tech-card" style="height: 222px">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>
              </svg>
            </div>
            <span>购买飘屏</span>
            <label class="header-toggle" style="margin-left: auto;">
              <input type="checkbox" v-model="config.purchaseEffect.enabled" />
              <span class="toggle-track"></span>
            </label>
            <button class="icon-reset-btn" title="恢复默认" @click="e => handleResetClick(e, resetPurchaseConfig)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>
          </div>
          <div class="card-body">
            <div class="config-list">
              <div :class="{ disabled: !config.purchaseEffect.enabled }">
                <div class="config-row">
                  <div class="config-item">
                    <label>随机频率 (秒)</label>
                    <div class="range-inputs">
                      <input type="number" v-model="config.purchaseEffect.frequencyMin" class="cyber-input mini" placeholder="从" />
                      <span class="range-sep">至</span>
                      <input type="number" v-model="config.purchaseEffect.frequencyMax" class="cyber-input mini" placeholder="到" />
                    </div>
                  </div>
                  <div class="config-item">
                    <label>随机人数 (人)</label>
                    <div class="range-inputs">
                      <input type="number" v-model="config.purchaseEffect.purchaseMin" class="cyber-input mini" placeholder="从" />
                      <span class="range-sep">至</span>
                      <input type="number" v-model="config.purchaseEffect.purchaseMax" class="cyber-input mini" placeholder="到" />
                    </div>
                  </div>
                </div>
                <div class="config-row" style="margin-top: 12px;">
                  <div class="config-item">
                    <label>字体大小</label>
                    <div class="slider-with-val">
                      <input type="range" min="12" max="40" v-model="config.purchaseEffect.fontSize" class="cyber-range" />
                      <span class="val-text">{{ config.purchaseEffect.fontSize }}px</span>
                    </div>
                  </div>
                </div>
                <!-- 占位填充，保持高度一致 -->
                <div class="config-row" style="margin-top: 12px; height: 38px; visibility: hidden;"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间：实时预览 (抖音直播间比例) -->
      <div class="feature-center">
        <div class="standard-phone-frame">
          <!-- 手机屏幕 -->
          <div class="standard-phone-screen">
            <!-- 推流模式下的视频占位 - 显示推流画面 -->


            <canvas
                ref="videoCanvas"
                class="video-element"
                :style="{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        opacity: 1,
                        pointerEvents: 'auto',
                        zIndex: 1
                      }"
            ></canvas>

            <!-- 直播间 UI 遮罩 (始终显示在视频上方) -->
            <div class="live-ui-overlay">
              <!-- 顶部状态栏 -->
              <div class="live-header">
                <div class="user-info-capsule">
                  <div class="avatar">
                    <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Douyin" alt="avatar">
                  </div>
                  <div class="meta">
                    <div class="name">MULTIFACED</div>
                    <div class="stats">12.8w 点赞</div>
                  </div>
                  <div class="follow">+ 关注</div>
                </div>
                <div class="viewer-tag">
                  <span class="val">3821</span>
                  <span class="lab">人</span>
                </div>
              </div>

              <!-- 底部评论区模拟 -->
              <div class="live-bottom-area">
                <div class="comment-gradient"></div>
              </div>

              <!-- 上下文字滚动特效 -->
              <div v-if="isPageActive && config.textScrollEffect.enabled"
                   class="text-scroll-container"
                   :style="textScrollStyle"
                   @mousedown="e => startDrag(e, 'textScrollEffect')">
                <div class="text-scroll-list" :style="{ animationDuration: (10 / config.textScrollEffect.speed) + 's' }">
                  <div v-for="(item, idx) in [...config.textScrollEffect.items, ...config.textScrollEffect.items]"
                       :key="idx"
                       class="text-scroll-item"
                       :style="{
                         color: config.textScrollEffect.color
                       }">
                    {{ item }}
                  </div>
                </div>
                <!-- 调整大小的节点 -->
                <div class="resize-handle resize-top" @mousedown="e => startResize(e, 'textScrollEffect', 'top')"></div>
                <div class="resize-handle resize-right" @mousedown="e => startResize(e, 'textScrollEffect', 'right')"></div>
                <div class="resize-handle resize-bottom" @mousedown="e => startResize(e, 'textScrollEffect', 'bottom')"></div>
                <div class="resize-handle resize-left" @mousedown="e => startResize(e, 'textScrollEffect', 'left')"></div>
                <div class="resize-handle resize-top-left" @mousedown="e => startResize(e, 'textScrollEffect', 'top-left')"></div>
                <div class="resize-handle resize-top-right" @mousedown="e => startResize(e, 'textScrollEffect', 'top-right')"></div>
                <div class="resize-handle resize-bottom-left" @mousedown="e => startResize(e, 'textScrollEffect', 'bottom-left')"></div>
                <div class="resize-handle resize-bottom-right" @mousedown="e => startResize(e, 'textScrollEffect', 'bottom-right')"></div>
              </div>

              <!-- 左右文字滚动特效 -->
              <div v-if="isPageActive && config.marqueeEffect.enabled"
                   class="marquee-container"
                   :style="marqueeStyle"
                   @mousedown="e => startDrag(e, 'marqueeEffect')">
                <div class="marquee-content" :style="{ animationDuration: (20 / config.marqueeEffect.speed) + 's' }">
                  <span v-for="(item, idx) in [...config.marqueeEffect.items, ...config.marqueeEffect.items]"
                        :key="idx"
                        class="marquee-item"
                        :style="{
                          color: config.marqueeEffect.color
                        }">
                    {{ item }}
                  </span>
                </div>
              </div>

              <!-- 动态闪动文字特效 -->
              <div v-if="isPageActive && config.flashTextEffect.enabled"
                   class="flash-text-container"
                   :style="flashTextStyle"
                   @mousedown="e => startDrag(e, 'flashTextEffect')">
                {{ config.flashTextEffect.text }}
              </div>

              <!-- 图片热卖特效 (核心功能) -->
                  <div v-if="isPageActive && config.hotImageEffect.enabled"
                      class="hot-sale-container"
                      :style="hotSaleStyle"
                      :key="config.hotImageEffect.count"
                      @mousedown="e => startDrag(e, 'hotImageEffect')">
                    <div class="hot-sale-wrap" :class="{ 'is-popping': isPopping }">
                      <img src="@/access/tx/hotSale.webp" alt="hot sale" class="hot-sale-img" />
                      <span class="hot-sale-x" :style="{ fontSize: (config.hotImageEffect.fontSize * 0.5 * previewScale) + 'px' }">x</span>
                      <span class="hot-sale-count" :style="{ fontSize: (config.hotImageEffect.fontSize * previewScale) + 'px' }">
                        {{ config.hotImageEffect.count>9999 ? 9999: config.hotImageEffect.count }}<span v-if="config.hotImageEffect.count>=9999" style="font-style: normal;margin-left: 2px;">+</span>
                      </span>
                    </div>
                  </div>

              <!-- 库存飘屏特效 -->
              <div v-if="isPageActive && config.inventoryEffect.enabled"
                   class="inventory-container"
                   :style="inventoryStyle"
                   :key="config.inventoryEffect.count"
                   @mousedown="e => startDrag(e, 'inventoryEffect')">
                <div class="inventory-wrap" :class="{ 'is-popping': isInventoryPopping }">
                  <img src="@/access/tx/stock.webp" alt="stock" class="inventory-img" />
                  <span class="inventory-x" :style="{ fontSize: (config.inventoryEffect.fontSize * 0.5 * previewScale) + 'px' }">x</span>
                  <span class="inventory-count" :style="{ fontSize: (config.inventoryEffect.fontSize * previewScale) + 'px' }">{{ config.inventoryEffect.count }}</span>
                </div>
              </div>

              <div v-if="isPageActive && config.purchaseEffect.enabled && config.purchaseEffect.visible"
                   class="purchase-banner"
                   :style="purchaseStyle"
                   @mousedown="e => startDrag(e, 'purchaseEffect')">
                <div class="purchase-banner-content">
                  <span class="purchase-user" :style="{ fontSize: (config.purchaseEffect.fontSize * previewScale) + 'px' }">
                    @{{ config.purchaseEffect.currentUser }}***等{{ config.purchaseEffect.currentCount }}人，正在去购买
                  </span>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <!-- 右侧：新增互动与倒计时配置 -->
      <div class="feature-right">
        <!-- 11. 上下文字滚动功能 (仿图片功能写) -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 4h10M3 8h10M3 12h7" stroke="#00d4ff" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </div>
            <span>上下文字滚动</span>
            <div class="tab-selectors">
              <button class="tab-mini" :class="{ active: activeTextTab === 'content' }" @click="activeTextTab = 'content'">内容</button>
              <button class="tab-mini" :class="{ active: activeTextTab === 'style' }" @click="activeTextTab = 'style'">样式</button>
            </div>
            <label class="header-toggle" style="margin-left: auto;">
              <input type="checkbox" v-model="config.textScrollEffect.enabled" />
              <span class="toggle-track"></span>
            </label>
            <button class="icon-reset-btn" title="恢复默认" @click="e => handleResetClick(e, resetTextScrollConfig)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>
          </div>
          <div class="card-body">
            <!-- 内容配置 -->
            <div v-show="activeTextTab === 'content'" class="config-list">
              <div class="config-item">
                <label>滚动内容 (每行一条)</label>
                <textarea
                  class="cyber-input"
                  rows="3"
                  :value="config.textScrollEffect.items.join('\n')"
                  @input="e => config.textScrollEffect.items = e.target.value.split('\n')"
                  placeholder="请输入滚动内容..."
                  style="width: 100%; resize: none; font-size: 12px; height: 105px;"
                ></textarea>
              </div>
            </div>

            <!-- 样式配置 -->
            <div v-show="activeTextTab === 'style'" class="config-list">
              <div class="config-row">
                <div class="config-item">
                  <label>字体大小</label>
                  <div class="slider-with-val">
                    <input type="range" min="10" max="40" v-model="config.textScrollEffect.fontSize" class="cyber-range" />
                    <span class="val-text">{{ config.textScrollEffect.fontSize }}px</span>
                  </div>
                </div>
                <div class="config-item">
                  <label>滚动速度</label>
                  <div class="slider-with-val">
                    <input type="range" min="0.1" max="5" step="0.1" v-model="config.textScrollEffect.speed" class="cyber-range" />
                    <span class="val-text">{{ config.textScrollEffect.speed }}x</span>
                  </div>
                </div>
                <div class="config-item">
                  <label>不透明度</label>
                  <div class="slider-with-val">
                    <input type="range" min="0" max="100" v-model="config.textScrollEffect.opacity" class="cyber-range" />
                    <span class="val-text">{{ config.textScrollEffect.opacity }}%</span>
                  </div>
                </div>
              </div>
              <div class="config-row" style="margin-top: 10px;">
                <div class="config-item">
                  <label>字体颜色</label>
                  <input type="color" v-model="config.textScrollEffect.color" class="color-picker" />
                </div>
                <div class="config-item">
                  <label>背景颜色</label>
                  <input type="color" v-model="config.textScrollEffect.backgroundColor" class="color-picker" />
                </div>
                <!-- 占位，保持三项布局一致性 -->
                <div class="config-item" style="flex: 1; visibility: hidden;"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 12. 左右文字滚动功能 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 8h12M5 5l-3 3 3 3M11 5l3 3-3 3" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <span>左右文字滚动</span>
            <div class="tab-selectors">
              <button class="tab-mini" :class="{ active: activeMarqueeTab === 'content' }" @click="activeMarqueeTab = 'content'">内容</button>
              <button class="tab-mini" :class="{ active: activeMarqueeTab === 'style' }" @click="activeMarqueeTab = 'style'">样式</button>
            </div>
            <label class="header-toggle" style="margin-left: auto;">
              <input type="checkbox" v-model="config.marqueeEffect.enabled" />
              <span class="toggle-track"></span>
            </label>
            <button class="icon-reset-btn" title="恢复默认" @click="e => handleResetClick(e, resetMarqueeConfig)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>
          </div>
          <div class="card-body">
            <!-- 内容配置 -->
            <div v-show="activeMarqueeTab === 'content'" class="config-list">
              <div class="config-item">
                <label>滚动内容 (每行一条)</label>
                <textarea
                  class="cyber-input"
                  rows="3"
                  :value="config.marqueeEffect.items.join('\n')"
                  @input="e => config.marqueeEffect.items = e.target.value.split('\n')"
                  placeholder="请输入左右滚动内容..."
                  style="width: 100%; resize: none; font-size: 12px; height: 105px;"
                ></textarea>
              </div>
            </div>

            <!-- 样式配置 -->
            <div v-show="activeMarqueeTab === 'style'" class="config-list">
              <div class="config-row">
                <div class="config-item">
                  <label>字体大小</label>
                  <div class="slider-with-val">
                    <input type="range" min="10" max="40" v-model="config.marqueeEffect.fontSize" class="cyber-range" />
                    <span class="val-text">{{ config.marqueeEffect.fontSize }}px</span>
                  </div>
                </div>
                <div class="config-item">
                  <label>滚动速度</label>
                  <div class="slider-with-val">
                    <input type="range" min="0.1" max="5" step="0.1" v-model="config.marqueeEffect.speed" class="cyber-range" />
                    <span class="val-text">{{ config.marqueeEffect.speed }}x</span>
                  </div>
                </div>
                <div class="config-item">
                  <label>不透明度</label>
                  <div class="slider-with-val">
                    <input type="range" min="0" max="100" v-model="config.marqueeEffect.opacity" class="cyber-range" />
                    <span class="val-text">{{ config.marqueeEffect.opacity }}%</span>
                  </div>
                </div>
              </div>
              <div class="config-row" style="margin-top: 10px;">
                <div class="config-item">
                  <label>字体颜色</label>
                  <input type="color" v-model="config.marqueeEffect.color" class="color-picker" />
                </div>
                <div class="config-item">
                  <label>背景颜色</label>
                  <input type="color" v-model="config.marqueeEffect.backgroundColor" class="color-picker" />
                </div>
                <!-- 占位 -->
                <div class="config-item" style="flex: 1; visibility: hidden;"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 13. 动态闪动文字功能 -->
        <div class="panel-card tech-card">
          <div class="card-header">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/>
                <path d="M5 3v4"/><path d="M19 17v4"/><path d="M3 5h4"/><path d="M17 19h4"/>
              </svg>
            </div>
            <span>动态闪动文字</span>
            <div class="tab-selectors">
              <button class="tab-mini" :class="{ active: activeFlashTab === 'content' }" @click="activeFlashTab = 'content'">内容</button>
              <button class="tab-mini" :class="{ active: activeFlashTab === 'style' }" @click="activeFlashTab = 'style'">样式</button>
            </div>
            <label class="header-toggle" style="margin-left: auto;">
              <input type="checkbox" v-model="config.flashTextEffect.enabled" />
              <span class="toggle-track"></span>
            </label>
            <button class="icon-reset-btn" title="恢复默认" @click="e => handleResetClick(e, resetFlashConfig)">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                <path d="M3 3v5h5"/>
              </svg>
            </button>
          </div>
          <div class="card-body">
            <!-- 内容配置 -->
            <div v-show="activeFlashTab === 'content'" class="config-list">
              <div class="config-item">
                <label>闪动文字内容</label>
                <textarea
                  class="cyber-input"
                  v-model="config.flashTextEffect.text"
                  placeholder="请输入闪动内容..."
                  style="width: 100%; font-size: 12px; height: 105px; resize: none;"
                ></textarea>
              </div>
            </div>

            <!-- 样式配置 -->
            <div v-show="activeFlashTab === 'style'" class="config-list">
              <div class="config-row">
                <div class="config-item">
                  <label>字体大小</label>
                  <div class="slider-with-val">
                    <input type="range" min="10" max="60" v-model="config.flashTextEffect.fontSize" class="cyber-range" />
                    <span class="val-text">{{ config.flashTextEffect.fontSize }}px</span>
                  </div>
                </div>
                <div class="config-item">
                  <label>闪烁速度</label>
                  <div class="slider-with-val">
                    <input type="range" min="0.5" max="10" step="0.5" v-model="config.flashTextEffect.speed" class="cyber-range" />
                    <span class="val-text">{{ config.flashTextEffect.speed }}x</span>
                  </div>
                </div>
                <div class="config-item">
                  <label>不透明度</label>
                  <div class="slider-with-val">
                    <input type="range" min="0" max="100" v-model="config.flashTextEffect.opacity" class="cyber-range" />
                    <span class="val-text">{{ config.flashTextEffect.opacity }}%</span>
                  </div>
                </div>
              </div>
              <div class="config-row" style="margin-top: 10px;">
                <div class="config-item">
                  <label>字体颜色</label>
                  <input type="color" v-model="config.flashTextEffect.color" class="color-picker" />
                </div>
                <div class="config-item">
                  <label>背景颜色</label>
                  <input type="color" v-model="config.flashTextEffect.backgroundColor" class="color-picker" />
                </div>
                <!-- 占位 -->
                <div class="config-item" style="flex: 1; visibility: hidden;"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotSale',
  inject: ['setGlobalVideoSrc', 'playGlobalVideo', 'pauseGlobalVideo', 'setGlobalVideoCurrentTime', 'setGlobalVideoMuted', 'setGlobalVideoLoop', 'getGlobalVideo', 'setOverlayVideoSrc', 'playOverlayVideo', 'pauseOverlayVideo', 'getOverlayVideo', 'globalCanvasState', 'updateGlobalCanvasState', 'syncCanvasToTarget'],
  data() {
    return {
      materialPath: '',
      activeTextTab: 'content',
      activeMarqueeTab: 'content',
      activeFlashTab: 'content',
      isPlaying: false,
      currentTime: 0,
      duration: 0,
      progressPercent: 0,
      isPopping: false,
      isInventoryPopping: false,
      hotSaleTimer: null,
      inventoryTimer: null,
      purchaseTimer: null,
      isPageActive: true,
      isMuted: false,
      volume: 1,
      syncingFromStore: false,
      dragging: null,
      dragStartX: 0,
      dragStartY: 0,
      dragStartLeft: 0,
      dragStartBottom: 0,
      syncCanvasFrameId: null,
      // 预览缩放相关
      previewScale: 1,
      previewOffsetX: 0,
      previewOffsetY: 0,
      dragOffset: { x: 0, y: 0 },
      // 购买飘屏上次显示时间
      lastPurchaseShowTime: null,
      config: {
        hotImageEffect: {
          enabled: false,
          count: 0,
          imagePath: "",
          bottom: 20,
          left: 20,
          fontSize: 24,
          frequency: 5,
          mode: 'single',
          startMin: 100,
          startMax: 200,
          increaseMin: 10,
          increaseMax: 50
        },
        inventoryEffect: {
          enabled: false,
          count: 100,
          imagePath: "",
          bottom: 20,
          left: 20,
          fontSize: 24,
          frequency: 6,
          mode: 'single',
          startMin: 50,
          startMax: 200,
          decreaseMin: 5,
          decreaseMax: 30
        },
        purchaseEffect: {
          enabled: false,
          frequencyMin: 2,
          frequencyMax: 10,
          purchaseMin: 1,
          purchaseMax: 10,
          fontSize: 16,
          visible: false,
          currentCount: 0,
          currentUser: "",
          bottom: 20,
          left: 20
        },
        textScrollEffect: {
          enabled: false,
          speed: 1,
          fontSize: 20,
          color: "#ffffff",
          backgroundColor: "rgba(0,0,0,0.5)",
          bottom: 100,
          left: 50,
          opacity: 100,
          items: ['欢迎来到直播间！', '喜欢的话请点个关注~', '感谢大家的支持！'],
          width: 160,
          height: 120
        },
        marqueeEffect: {
          enabled: false,
          speed: 1,
          fontSize: 18,
          color: "#ffeb3b",
          backgroundColor: "rgba(0,0,0,0.3)",
          bottom: 50,
          left: 0,
          opacity: 100,
          items: ['限时特惠！', '买一送一！', '最后一天！']
        },
        flashTextEffect: {
          enabled: false,
          speed: 1,
          fontSize: 28,
          color: "#ff5722",
          backgroundColor: "rgba(0,0,0,0.6)",
          bottom: 150,
          left: 50,
          opacity: 100,
          text: "抢购中..."
        }
      }
    }
  },
  computed: {
    isVirtualCameraLive() {
      return this.$store.state.isVirtualCameraLive
    },
    videoUrl() {
      const media = this.$store.state.currentMedia
      if (media && media.type === 'video') {
        return media.url
      }
      return null
    },
    hiddenPlayerStyle() {
      return {
        position: 'absolute',
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        opacity: this.isVirtualCameraLive ? 0 : 1,
        pointerEvents: this.isVirtualCameraLive ? 'none' : 'auto'
      }
    },
    // 计算属性：热卖特效的样式
    hotSaleStyle() {
      return {
        bottom: (this.config.hotImageEffect.bottom * this.previewScale) + 'px',
        left: (this.config.hotImageEffect.left * this.previewScale) + 'px'
      }
    },
    // 计算属性：库存特效的样式
    inventoryStyle() {
      return {
        bottom: (this.config.inventoryEffect.bottom * this.previewScale) + 'px',
        left: (this.config.inventoryEffect.left * this.previewScale) + 'px'
      }
    },
    // 计算属性：购买特效的样式
    purchaseStyle() {
      return {
        bottom: (this.config.purchaseEffect.bottom * this.previewScale) + 'px',
        left: (this.config.purchaseEffect.left * this.previewScale) + 'px'
      }
    },
    // 计算属性：文字滚动特效的样式
    textScrollStyle() {
      return {
        bottom: (this.config.textScrollEffect.bottom * this.previewScale) + 'px',
        left: (this.config.textScrollEffect.left * this.previewScale) + 'px',
        opacity: this.config.textScrollEffect.opacity / 100,
        backgroundColor: this.config.textScrollEffect.backgroundColor,
        fontSize: (this.config.textScrollEffect.fontSize * this.previewScale) + 'px',
        height: (this.config.textScrollEffect.height * this.previewScale) + 'px',
        width: (this.config.textScrollEffect.width * this.previewScale) + 'px'
      }
    },
    // 计算属性：跑马灯特效的样式
    marqueeStyle() {
      return {
        bottom: (this.config.marqueeEffect.bottom * this.previewScale) + 'px',
        left: (this.config.marqueeEffect.left * this.previewScale) + 'px',
        opacity: this.config.marqueeEffect.opacity / 100,
        backgroundColor: this.config.marqueeEffect.backgroundColor,
        fontSize: (this.config.marqueeEffect.fontSize * this.previewScale) + 'px',
        width: (this.config.marqueeEffect.fontSize * 12 * this.previewScale) + 'px'
      }
    },
    // 计算属性：闪烁文字特效的样式
    flashTextStyle() {
      return {
        bottom: (this.config.flashTextEffect.bottom * this.previewScale) + 'px',
        left: (this.config.flashTextEffect.left * this.previewScale) + 'px',
        opacity: this.config.flashTextEffect.opacity / 100,
        backgroundColor: this.config.flashTextEffect.backgroundColor,
        fontSize: (this.config.flashTextEffect.fontSize * this.previewScale) + 'px',
        color: this.config.flashTextEffect.color,
        animationDuration: (2 / this.config.flashTextEffect.speed) + 's'
      }
    }
  },
  mounted() {
    this.syncFromStore()
    this.startHotSaleTimers()
    this.$nextTick(() => {
      this.initPlayer()
      this.updatePreviewState()
    })
    // 监听窗口大小变化
    window.addEventListener('resize', this.handlePreviewResize)

    console.log('[HotSale] 页面已激活')
    this.isPageActive = true
    this.startCanvasSync()
    this.$nextTick(() => {
      this.updatePreviewState()
    })
  },
  activated() {

  },
  deactivated() {
    // console.log('[HotSale] 页面离开')
    // this.isPageActive = false
    // this.stopCanvasSync()
  },
  beforeDestroy() {
   /* this.stopHotSaleTimers()
    this.stopCanvasSync()
    window.removeEventListener('resize', this.handlePreviewResize)*/
  },
  methods: {
    syncFromStore() {
      this.syncingFromStore = true
      try {
        const storeConfig = JSON.parse(JSON.stringify(this.$store.state.hotSaleParams))
        // 为旧数据补充默认值
        if (!storeConfig.textScrollEffect.width) {
          storeConfig.textScrollEffect.width = 160
        }
        if (!storeConfig.textScrollEffect.height) {
          storeConfig.textScrollEffect.height = 120
        }
        if (typeof storeConfig.purchaseEffect.bottom !== 'number') {
          storeConfig.purchaseEffect.bottom = 20
        }
        if (typeof storeConfig.purchaseEffect.left !== 'number') {
          storeConfig.purchaseEffect.left = 20
        }
        this.config = storeConfig
      } finally {
        this.syncingFromStore = false
      }
    },
    syncToStore() {
      this.$store.commit('UPDATE_HOT_SALE_PARAMS', JSON.parse(JSON.stringify(this.config)))
    },
    initPlayer() {
      if (this.$refs.videoPlayerRef) {
        this.$refs.videoPlayerRef.addEventListener('loadedmetadata', () => {
          this.duration = this.$refs.videoPlayerRef.duration
        })
      }
    },
    startHotSaleTimers() {
      this.hotSaleTimer = setInterval(() => {
        if (this.config.hotImageEffect.enabled && this.isPageActive) {
          this.triggerHotSalePop()
        }
      }, this.config.hotImageEffect.frequency * 1000 || 5000)

      this.inventoryTimer = setInterval(() => {
        if (this.config.inventoryEffect.enabled && this.isPageActive) {
          this.triggerInventoryPop()
        }
      }, this.config.inventoryEffect.frequency * 1000 || 6000)

      // 购买飘屏：每秒检查一次是否需要显示
      this.purchaseTimer = setInterval(() => {
        if (this.config.purchaseEffect.enabled && this.isPageActive) {
          this.triggerPurchase()
        }
      }, 1000)
    },
    stopHotSaleTimers() {
      if (this.hotSaleTimer) clearInterval(this.hotSaleTimer)
      if (this.inventoryTimer) clearInterval(this.inventoryTimer)
      if (this.purchaseTimer) clearInterval(this.purchaseTimer)
    },
    triggerHotSalePop() {
      const effect = this.config.hotImageEffect
      const startValue = Math.floor(effect.startMin + Math.random() * (effect.startMax - effect.startMin))
      const increase = Math.floor(effect.increaseMin + Math.random() * (effect.increaseMax - effect.increaseMin))

      this.isPopping = true

      if (effect.mode === 'single') {
        effect.count = startValue + increase
      } else {
        effect.count += increase
      }

      setTimeout(() => {
        this.isPopping = false
      }, 300)
    },
    triggerInventoryPop() {
      const effect = this.config.inventoryEffect
      const startValue = Math.floor(effect.startMin + Math.random() * (effect.startMax - effect.startMin))
      const decrease = Math.floor(effect.decreaseMin + Math.random() * (effect.decreaseMax - effect.decreaseMin))

      this.isInventoryPopping = true

      if (effect.mode === 'single') {
        effect.count = Math.max(0, startValue - decrease)
      } else {
        effect.count = Math.max(0, effect.count - decrease)
      }

      setTimeout(() => {
        this.isInventoryPopping = false
      }, 300)
    },
    triggerPurchase() {
      const effect = this.config.purchaseEffect
      const freqMin = effect.frequencyMin || 2
      const freqMax = effect.frequencyMax || 10
      const purchaseMin = effect.purchaseMin || 1
      const purchaseMax = effect.purchaseMax || 10

      // 计算随机出现的概率：最小频率时概率最高，最大频率时概率最低
      // 比如：频率 2 秒时，每秒检查一次，概率为 0.5；频率 10 秒时，概率为 0.1
      const averageFreq = (freqMin + freqMax) / 2
      const showProbability = 1 / averageFreq // 平均每隔 averageFreq 秒显示一次

      // 添加一个变量来跟踪上次显示时间，避免太频繁
      const now = Date.now()
      if (this.lastPurchaseShowTime && now - this.lastPurchaseShowTime < freqMin * 1000) {
        return // 距离上次显示还不到最小间隔，不显示
      }

      const shouldShow = Math.random() < showProbability
      if (shouldShow) {
        this.lastPurchaseShowTime = now
        effect.visible = true
        effect.currentCount = Math.floor(purchaseMin + Math.random() * (purchaseMax - purchaseMin))
        effect.currentUser = this.getRandomUser()

        setTimeout(() => {
          effect.visible = false
        }, 2000)
      }
    },
    getRandomUser() {
      const names = ['小明', '小红', '阿强', '美琪', '大卫', '苏菲', '俊杰', '雅婷', '伟强', '诗涵']
      return names[Math.floor(Math.random() * names.length)]
    },
    selectFile() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'video/*,audio/*'
      input.onchange = (e) => {
        if (e.target.files && e.target.files[0]) {
          const file = e.target.files[0]
          this.materialPath = file.path || file.name
          const url = URL.createObjectURL(file)
          const isVideo = file.type.startsWith('video/')

          this.$store.dispatch('setCurrentMedia', {
            url: url,
            type: isVideo ? 'video' : 'audio',
            name: file.name
          })
        }
      }
      input.click()
    },
    handleDrop(e) {
      e.preventDefault()
      e.stopPropagation()

      const files = e.dataTransfer?.files
      if (!files || files.length === 0) return

      const file = files[0]
      this.materialPath = file.path || file.name
      const url = URL.createObjectURL(file)
      const isVideo = file.type.startsWith('video/')

      this.$store.dispatch('setCurrentMedia', {
        url: url,
        type: isVideo ? 'video' : 'audio',
        name: file.name
      })
    },
    handlePathEnter() {
      if (this.materialPath) {
        console.log('Path entered:', this.materialPath)
      }
    },
    handleResetClick(e, resetFn) {
      e.stopPropagation()
      if (resetFn && typeof resetFn === 'function') {
        resetFn()
      }
    },
    resetConfig() {
      this.config.hotImageEffect = {
        enabled: false,
        count: 0,
        imagePath: "",
        bottom: 0,
        left: 0,
        fontSize: 24,
        frequency: 5,
        mode: 'single',
        startMin: 100,
        startMax: 200,
        increaseMin: 10,
        increaseMax: 50
      }
    },
    resetInventoryConfig() {
      this.config.inventoryEffect = {
        enabled: false,
        count: 100,
        imagePath: "",
        bottom: 0,
        left: 0,
        fontSize: 24,
        frequency: 6,
        mode: 'single',
        startMin: 50,
        startMax: 200,
        decreaseMin: 5,
        decreaseMax: 30
      }
    },
    resetPurchaseConfig() {
      this.config.purchaseEffect = {
        enabled: false,
        frequencyMin: 2,
        frequencyMax: 10,
        purchaseMin: 1,
        purchaseMax: 10,
        fontSize: 16,
        visible: false,
        currentCount: 0,
        currentUser: "",
        bottom: 20,
        left: 20
      }
    },
    resetTextScrollConfig() {
      this.config.textScrollEffect = {
        enabled: false,
        speed: 1,
        fontSize: 20,
        color: '#ffffff',
        backgroundColor: 'rgba(0,0,0,0.5)',
        bottom: 100,
        left: 50,
        opacity: 100,
        items: ['欢迎来到直播间！', '喜欢的话请点个关注~', '感谢大家的支持！'],
        width: 160,
        height: 120,
      }
    },
    resetMarqueeConfig() {
      this.config.marqueeEffect = {
        enabled: false,
        speed: 1,
        fontSize: 18,
        color: '#ffeb3b',
        backgroundColor: 'rgba(0,0,0,0.3)',
        bottom: 50,
        left: 0,
        opacity: 100,
        items: ['限时特惠！', '买一送一！', '最后一天！']
      }
    },
    resetFlashConfig() {
      this.config.flashTextEffect = {
        enabled: false,
        speed: 1,
        fontSize: 28,
        color: '#ff5722',
        backgroundColor: 'rgba(0,0,0,0.6)',
        bottom: 150,
        left: 50,
        opacity: 100,
        text: '抢购中...'
      }
    },
    onPlayerPlay() {
      this.isPlaying = true
    },
    onPlayerPause() {
      this.isPlaying = false
    },
    onPlayerTimeUpdate() {
      if (this.$refs.videoPlayerRef) {
        this.currentTime = this.$refs.videoPlayerRef.currentTime
        this.progressPercent = (this.currentTime / this.duration) * 100
      }
    },
    onPlayerLoadedMetadata() {
      if (this.$refs.videoPlayerRef) {
        this.duration = this.$refs.videoPlayerRef.duration
      }
    },
    onVideoEnded() {
      this.isPlaying = false
    },
    onStreamError() {
      console.error('Stream error')
    },
    onPlayerError() {
      console.error('Player error')
    },
    togglePlayback() {
      if (this.$refs.videoPlayerRef) {
        if (this.isPlaying) {
          this.$refs.videoPlayerRef.pause()
        } else {
          this.$refs.videoPlayerRef.play()
        }
      }
    },
    startSeek(e) {
      e.preventDefault()
      if (this.$refs.videoPlayerRef) {
        const rect = e.currentTarget.getBoundingClientRect()
        const x = e.clientX - rect.left
        const percent = Math.max(0, Math.min(1, x / rect.width))
        this.$refs.videoPlayerRef.currentTime = percent * this.duration
      }
    },
    formatTime(seconds) {
      if (!isFinite(seconds)) return '00:00'
      const mins = Math.floor(seconds / 60)
      const secs = Math.floor(seconds % 60)
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    // 更新预览状态（缩放比例）
    updatePreviewState() {
      const container = document.querySelector('.standard-phone-screen')
      if (!container) return
      
      const containerRect = container.getBoundingClientRect()
      // 标准容器尺寸是360x640
      this.previewScale = containerRect.width / 360
    },
    // 处理窗口大小变化
    handlePreviewResize() {
      this.updatePreviewState()
    },
    startDrag(e, type) {
      e.preventDefault()
      e.stopPropagation()
      
      const container = document.querySelector('.standard-phone-screen')
      if (!container) return
      const containerRect = container.getBoundingClientRect()
      
      // 计算容器的缩放比例
      const scale = containerRect.width / 360
      
      const startX = e.clientX
      const startY = e.clientY
      const cfg = this.config[type]
      const startLeft = cfg.left
      const startBottom = cfg.bottom
      
      const onMouseMove = (ev) => {
        // 像素差值转换为标准坐标
        const deltaX = (ev.clientX - startX) / scale
        const deltaY = (ev.clientY - startY) / scale
        cfg.left = startLeft + deltaX
        cfg.bottom = startBottom - deltaY
      }
      
      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }
      
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },
    startResize(e, type, direction) {
      e.preventDefault()
      e.stopPropagation()
      
      const container = document.querySelector('.standard-phone-screen')
      if (!container) return
      const containerRect = container.getBoundingClientRect()
      
      // 计算容器的缩放比例
      const scale = containerRect.width / 360
      
      const startX = e.clientX
      const startY = e.clientY
      const cfg = this.config[type]
      const startLeft = cfg.left
      const startBottom = cfg.bottom
      const startWidth = cfg.width
      const startHeight = cfg.height

      const onMouseMove = (ev) => {
        const dx = (ev.clientX - startX) / scale
        const dy = (ev.clientY - startY) / scale

        // 向右：增加宽度
        if (direction.includes('right')) {
          cfg.width = Math.max(50, startWidth + dx)
        }
        // 向左：减少宽度，同时调整左边位置
        if (direction.includes('left')) {
          const newWidth = Math.max(50, startWidth - dx)
          const widthDiff = newWidth - startWidth
          cfg.width = newWidth
          cfg.left = startLeft - widthDiff
        }
        // 向下：增加高度（因为 bottom 是距离底部的距离，所以向下拖动会减小 bottom，增加高度）
        if (direction.includes('bottom')) {
          const newHeight = Math.max(50, startHeight + dy)
          const heightDiff = newHeight - startHeight
          cfg.height = newHeight
          cfg.bottom = startBottom - heightDiff
        }
        // 向上：减少高度（向上拖动会增加 bottom，减少高度）
        if (direction.includes('top')) {
          cfg.height = Math.max(50, startHeight - dy)
        }
      }

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },
    stopDrag() {
      this.dragging = null
      document.removeEventListener('mousemove', this.doDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },
    startCanvasSync() {
      if (this.syncCanvasFrameId) {
        cancelAnimationFrame(this.syncCanvasFrameId)
      }
        const sync = () => {
          const videoCanvas = this.$refs.videoCanvas
          if (videoCanvas) {
            this.syncCanvasToTarget(videoCanvas)
          }
          this.syncCanvasFrameId = requestAnimationFrame(sync)
        }
        sync()
    },
    stopCanvasSync() {
      if (this.syncCanvasFrameId) {
        cancelAnimationFrame(this.syncCanvasFrameId)
        this.syncCanvasFrameId = null
      }
    }
  },
  watch: {
    config: {
      handler(newConfig, oldConfig) {
        if (!this.syncingFromStore) {
          this.syncToStore()
          
          // 如果频率配置变化了，重新启动定时器
          if (
            (newConfig.hotImageEffect && oldConfig.hotImageEffect &&
             newConfig.hotImageEffect.frequency !== oldConfig.hotImageEffect.frequency) ||
            (newConfig.inventoryEffect && oldConfig.inventoryEffect &&
             newConfig.inventoryEffect.frequency !== oldConfig.inventoryEffect.frequency) ||
            (newConfig.purchaseEffect && oldConfig.purchaseEffect &&
             (newConfig.purchaseEffect.frequencyMin !== oldConfig.purchaseEffect.frequencyMin ||
              newConfig.purchaseEffect.frequencyMax !== oldConfig.purchaseEffect.frequencyMax))
          ) {
            this.stopHotSaleTimers()
            this.startHotSaleTimers()
          }
        }
      },
      deep: true
    },
    '$store.state.hotSaleParams': {
      handler(newVal) {
        if (!this.syncingFromStore && JSON.stringify(newVal) !== JSON.stringify(this.config)) {
          this.syncFromStore()
        }
      },
      deep: true
    },
    videoUrl: {
      handler() {
        if (this.videoUrl) {
          this.$nextTick(() => {
            this.initPlayer()
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.hot-sale-page {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center; /* 核心：水平居中 */
  overflow-y: auto;
}

.hot-sale-content {
  display: grid;
  grid-template-columns: 370px 1fr 370px;
  gap: 15px;
  align-items: start;
  max-width: 1400px;
  width: 100%;
  padding: 0 20px;
  position: relative;
  left: -10px; /* 极微调：向左移动一丢丢，解决视觉居中偏差 */
}

.feature-left, .feature-right {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 5px;
}

.feature-center {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 5px 0 20px 0;
}

/* 视频去重风格的卡片样式 */
.panel-card {
  background: rgba(20, 20, 20, 0.6);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  overflow: hidden;
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.3),
    0 0 20px rgba(0, 212, 255, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.tech-card {
  position: relative;
}

.tech-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.4), transparent);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  border-bottom: 1px solid #2a2a2a;
  color: #b0b0b0;
  font-size: 12px;
  font-weight: 600;
}

.card-header span {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
  flex: 1;
}

.tab-selectors {
  display: flex;
  gap: 4px;
  background: rgba(255, 255, 255, 0.05);
  padding: 3px; /* 高度稍微加高一点点，从 2px 增加到 3px */
  border-radius: 4px;
  margin-right: 8px;
}

.tab-mini {
  background: none;
  border: none;
  color: #888;
  font-size: 10px;
  padding: 4px 10px; /* 内边距增加，提升点击区域和整体高度 */
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-mini.active {
  background: var(--accent);
  color: #000;
  font-weight: bold;
}

.icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 212, 255, 0.12);
  border-radius: 8px;
  color: #00d4ff;
}

.card-header svg {
  filter: drop-shadow(0 0 4px rgba(0, 212, 255, 0.4));
}

.card-body {
  padding: 10px;
  min-height: 145px;
  display: flex;
  flex-direction: column;
}

.path-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.path-input {
  flex: 1;
  min-width: 0;
  background: linear-gradient(180deg, #1a1a1a 0%, #121212 100%);
  border: 1px solid #2a2a2a;
  color: #c0c0c0;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-family: 'SF Mono', monospace;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
  transition: all 0.2s ease;
}

.path-input:hover {
  border-color: #00d4ff;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.3);
}

.path-input:focus {
  outline: none;
  border-color: #00d4ff;
  box-shadow: 0 0 12px rgba(0, 212, 255, 0.35), inset 0 1px 2px rgba(0, 0, 0, 0.3);
}

.path-input-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #151515 0%, #0f0f0f 100%);
  padding: 2px;
  border-radius: 6px;
  border: 1px solid #2a2a2a;
}

.path-btn {
  background: linear-gradient(180deg, #202020 0%, #1a1a1a 100%);
  border: 1px solid #2a2a2a;
  color: #a0a0a0;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.path-btn:hover {
  border-color: #00d4ff;
  color: #00d4ff;
  background: linear-gradient(180deg, rgba(0, 212, 255, 0.15) 0%, rgba(0, 212, 255, 0.08) 100%);
  box-shadow: 0 0 12px rgba(0, 212, 255, 0.25);
}

.config-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.header-toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  flex: none;
}

.card-header .header-toggle {
  margin-left: 10px; /* 在恢复默认按钮后面增加间距 */
}

.header-toggle input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer;
}

.toggle-track {
  width: 44px;
  height: 22px;
  background: #2a2a2a;
  border-radius: 11px;
  position: relative;
  transition: all 0.2s ease;
  border: 1px solid #3a3a3a;
}

.toggle-track::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #666;
  border-radius: 50%;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

.header-toggle input:checked + .toggle-track {
  background: #00d4ff;
  border-color: #00d4ff;
}

.header-toggle input:checked + .toggle-track::after {
  left: 26px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.icon-reset-btn {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #888;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: 8px;
  flex: none;
}

.icon-reset-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
  color: #fff;
  transform: rotate(-30deg);
}

.icon-reset-btn:active {
  transform: scale(0.85) rotate(-90deg); /* 点击时缩小并大幅旋转 */
  background: rgba(78, 205, 196, 0.2); /* 点击时变色提示 */
  border-color: #4ecdc4;
  transition: all 0.1s;
}

/* 点击时的旋转动画 */
.btn-spin-anim svg {
  animation: btn-spin 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes btn-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(-360deg); }
}

/* 手机预览框架 */
.standard-phone-screen {
  width: 100%;
  height: 100%;
  background: #000;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

.live-video-player {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

/* 播放器控制条 (下方显示) */
.player-control-bar {
  height: 0;
  background: #111;
  border-top: 1px solid #222;
  display: flex;
  align-items: center;
  padding: 0 15px;
  gap: 15px;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  z-index: 60;
}

.phone-frame:hover .player-control-bar {
  height: 60px;
  opacity: 1;
  padding: 10px 15px;
}

.play-btn-mini {
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}

.play-btn-mini:hover {
  transform: scale(1.1);
  color: #00d4ff;
}

.progress-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 10px; /* 进度条长度稍微缩短一点点 */
}

.progress-bar-wrap {
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  cursor: pointer;
  position: relative;
}

.progress-bg {
  width: 100%;
  height: 100%;
  position: relative;
}

.progress-fill {
  height: 100%;
  background: #00d4ff;
  border-radius: 2px;
  transition: width 0.1s linear;
}

.time-info {
  display: flex;
  gap: 4px;
  color: #666;
  font-size: 10px;
  font-family: 'JetBrains Mono', monospace;
}

.volume-section {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #888;
}

.volume-slider-mini {
  width: 50px;
  height: 3px;
  -webkit-appearance: none;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1.5px;
  outline: none;
}

.volume-slider-mini::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 8px;
  height: 8px;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
}

/* 直播间 UI 遮罩 */
.live-ui-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  pointer-events: none; /* 让点击穿透到视频播放器，如果需要的话 */
}

.live-ui-overlay > * {
  pointer-events: auto; /* 恢复子元素的点击事件 */
}

/* 上传框样式 */
.upload-box {
  background: rgba(255, 255, 255, 0.03);
  border: 2px dashed rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.upload-box:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: var(--accent);
}

.upload-placeholder, .upload-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--text-secondary);
}

.upload-placeholder .icon, .upload-success .icon {
  font-size: 24px;
}

.upload-success {
  color: #10b981;
}

/* 直播间顶部 */
.live-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

.user-info-capsule {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 0, 0, 0.5);
  padding: 6px 10px;
  border-radius: 20px;
}

.user-info-capsule .avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
}

.user-info-capsule .avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info-capsule .meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-info-capsule .name {
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}

.user-info-capsule .stats {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11px;
}

.user-info-capsule .follow {
  background: #fe2c55;
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.viewer-tag {
  background: rgba(0, 0, 0, 0.5);
  padding: 4px 10px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.viewer-tag .val {
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.viewer-tag .lab {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
}

/* 右侧按钮 */
.live-right-actions {
  position: absolute;
  right: 12px;
  bottom: 120px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 10;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #fff;
  font-size: 10px;
}

.icon-circle {
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

/* 底部评论区 */
.live-bottom-area {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px;
  z-index: 5;
}

.comments-mock {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.comment {
  background: rgba(0, 0, 0, 0.3);
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #fff;
  max-width: 80%;
}

.comment span {
  color: rgba(255, 255, 255, 0.6);
  margin-right: 4px;
}

/* 上下文字滚动 */
.text-scroll-container {
  position: absolute;
  z-index: 100;
  cursor: move;
  user-select: none;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  border-radius: 0.5em;
  padding: 0.5em;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* 调整大小的节点 */
.resize-handle {
  position: absolute;
  background: #00d4ff;
  border: 1px solid #fff;
  border-radius: 50%;
  z-index: 10;
  box-shadow: 0 0 4px rgba(0, 212, 255, 0.8);
}

.resize-top {
  width: 10px;
  height: 10px;
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
}

.resize-right {
  width: 10px;
  height: 10px;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: ew-resize;
}

.resize-bottom {
  width: 10px;
  height: 10px;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  cursor: ns-resize;
}

.resize-left {
  width: 10px;
  height: 10px;
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: ew-resize;
}

.resize-top-left {
  width: 10px;
  height: 10px;
  top: -5px;
  left: -5px;
  cursor: nwse-resize;
}

.resize-top-right {
  width: 10px;
  height: 10px;
  top: -5px;
  right: -5px;
  cursor: nesw-resize;
}

.resize-bottom-left {
  width: 10px;
  height: 10px;
  bottom: -5px;
  left: -5px;
  cursor: nesw-resize;
}

.resize-bottom-right {
  width: 10px;
  height: 10px;
  bottom: -5px;
  right: -5px;
  cursor: nwse-resize;
}

.text-scroll-list {
  display: flex;
  flex-direction: column;
  animation: text-scroll-up linear infinite;
}

.text-scroll-item {
  white-space: nowrap;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  line-height: 1.5;
}

@keyframes text-scroll-up {
  0% { transform: translateY(0); }
  100% { transform: translateY(-50%); }
}

.marquee-container {
  position: absolute;
  white-space: nowrap;
  padding: 0.4em 0.8em;
  border-radius: 0.3em;
  cursor: move;
  z-index: 10;
  overflow: hidden;
  max-width: 90%;
}

.marquee-content {
  display: inline-block;
  animation: marquee-scroll linear infinite;
}

.marquee-item {
  display: inline-block;
  padding-right: 40px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

@keyframes marquee-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
} /* 滚到一半，因为我们复制了一份内容实现无缝 */

.flash-text-container {
  position: absolute;
  padding: 0.3em 0.8em;
  border-radius: 0.4em;
  cursor: move;
  z-index: 11;
  font-weight: 800;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  animation: flash-breathing ease-in-out infinite;
  white-space: nowrap;
}

@keyframes flash-breathing {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.2; transform: scale(0.95); }
}

/* 热卖特效容器 (抖音核心) */
.hot-sale-container {
  position: absolute;
  z-index: 100;
  cursor: move;
  user-select: none;
  animation: hot-sale-entry 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

.hot-sale-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 32px;
  background: linear-gradient(270.02deg, rgba(255, 177, 26, 0) 3.96%, rgba(255, 177, 26, 0.6) 20.3%, rgba(255, 177, 26, 0.8) 86.14%);
  border-radius: 16px 0 0 16px;
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
  padding-right: 10px;
}

.hot-sale-wrap.is-popping {
  transform: scale(1.2);
}

.hot-sale-img {
  height: 32px; /* 调整图片高度以适应 32px 的容器 */
  width: auto;
  display: block;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.hot-sale-x {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 29px;
  margin-left: 4px;
  font-style: italic !important;
  font-family: PingFang SC,DFPKingGothicGB-Regular,sans-serif;
  position:relative;
  top: 3px;
}

.hot-sale-count {
  position: relative;
  color: #fff;
  font-size: 26px;
  line-height: 29px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  font-style: italic;
  font-weight: 700;
  margin-left: 5px;
  font-family: PingFang SC, DFPKingGothicGB-Regular, sans-serif;

}

@keyframes hot-sale-entry {
  from { opacity: 0; transform: translateX(-50px) scale(0.8); }
  to { opacity: 1; transform: translateX(0) scale(1); }
}

@keyframes hot-sale-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

/* 库存飘屏特效 */
.inventory-container {
  position: absolute;
  z-index: 99;
  cursor: move;
  user-select: none;
  animation: hot-sale-entry 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

.inventory-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 32px;
  background: linear-gradient(89.99deg,rgba(255,69,181,.8) 10.09%,rgba(255,69,181,.7) 79.16%,rgba(255,69,181,0) 97.76%);
  border-radius: 16px 0 0 16px;
  padding-right: 12px;
  color: #fff;
  font-family: PingFang SC, sans-serif;
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.inventory-wrap.is-popping {
  transform: scale(1.15);
}

.inventory-img {
  height: 32px;
  width: auto;
  display: block;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.inventory-x {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 29px;
  margin-left: 4px;
  font-style: italic !important;
  font-family: PingFang SC,DFPKingGothicGB-Regular,sans-serif;
  position:relative;
  top: 3px;
}

.inventory-count {
  position: relative;
  color: #fff;
  font-size: 24px;
  line-height: 29px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  pointer-events: none;
  font-style: italic;
  font-weight: 700;
  margin-left: 5px;
  font-family: PingFang SC, DFPKingGothicGB-Regular, sans-serif;
  top: 1px;
}

/* 购买飘屏样式 */
.purchase-banner {
  height: 64px;
  width: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 20px;
  animation: purchase-banner-entry 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

@keyframes purchase-banner-entry {
  from { transform: translateX(-100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

.purchase-banner-content {
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.purchase-user {
  color: #ffffff;
  font-weight: 700;
  white-space: nowrap;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

/* UI 辅助样式 */
.color-picker {
  width: 100%;
  height: 32px;
  padding: 2px;
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  cursor: pointer;
}

.slider-with-val {
  display: flex;
  align-items: center;
  gap: 8px; /* 间距从 12px 缩减到 8px */
  margin-top: 8px;
}

.cyber-range {
  width: 50px; /* 缩短滑动条宽度 */
  -webkit-appearance: none;
  height: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  outline: none;
}

.cyber-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 12px;
  height: 12px;
  background: #00d4ff;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.5);
}

.val-text {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px; /* 缩小一点 */
  color: #00d4ff;
  min-width: 35px; /* 从 40px 减少 */
  text-align: right;
}

/* 配置卡片增强 */
.config-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.config-list.disabled {
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(1);
}

.config-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.config-item.horizontal {
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.config-row {
  display: flex;
  gap: 12px; /* 从 16px 减少到 12px */
  align-items: flex-start;
}

.config-row .config-item {
  flex: 1;
}

.config-item label {
  font-size: 12px;
  color: var(--text-secondary);
}

.config-item.horizontal label {
  white-space: nowrap;
}

.field-label {
  font-size: 12px;
  color: var(--text-secondary);
  margin-right: 4px;
}

.field-unit {
  font-size: 12px;
  color: var(--text-muted);
  margin-left: 4px;
}

.label-with-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}

.cyber-input {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  padding: 10px;
  border-radius: 8px;
  outline: none;
  font-size: 11px; /* 文字缩小一点点 */
}

/* 移除数字输入框的上下调节箭头 */
.cyber-input[type="number"]::-webkit-outer-spin-button,
.cyber-input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.cyber-input[type="number"] {
  -moz-appearance: textfield;
}

.config-item.horizontal .cyber-input {
  flex: none;
}

.cyber-input.mini {
  width: 40px; /* 进一步缩短，从 48px 缩短到 40px */
  padding: 4px 2px; /* 进一步压缩内边距 */
  text-align: center;
  flex: none;
}

.action-btn-text {
  background: transparent;
  border: none;
  color: var(--accent);
  font-size: 11px;
  cursor: pointer;
  padding: 0;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.action-btn-text:hover {
  opacity: 1;
  text-decoration: underline;
}

/* 新增配置项样式 */
.radio-group {
  display: flex;
  gap: 8px;
  background: rgba(255, 255, 255, 0.03);
  padding: 4px;
  border-radius: 8px;
}

.radio-btn {
  flex: 1;
  padding: 6px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-size: 12px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.radio-btn.active {
  background: var(--accent);
  color: #000;
  font-weight: 600;
}

.range-inputs {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-sep {
  color: var(--text-muted);
  font-size: 12px;
}

.cyber-slider {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  appearance: none;
  outline: none;
}

.cyber-slider::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background: var(--accent);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 10px var(--accent-glow);
}

.divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.05);
  margin: 8px 0;
}

.cyber-color {
  width: 100%;
  height: 32px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  cursor: pointer;
  padding: 2px;
}
</style>
